import { render, staticRenderFns } from "./TableNClosedCash.vue?vue&type=template&id=488b04d7"
import script from "./TableNClosedCash.vue?vue&type=script&lang=js"
export * from "./TableNClosedCash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports